export const auth = {
  login: {
    heading: 'Log in',
    subtitle: 'Welcome to EachTeach',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forgot your password?',
    invalidCredentials: 'The email or password is incorrect',
    submitting: 'Logging in...',
    submit: 'Log in',
    noAccount: 'Don\'t have an account?',
    register: 'Sign up',
  },

  forgotPassword: {
    heading: 'Forgot your password?',
    intro: 'Enter your registered email address. We will send you a link to reset your password.',
    sendError: 'Failed to send the email. Please check your email address.',
    sentTitle: 'Email sent',
    sentBody: 'We sent a password reset link to {{email}}. Please check your inbox.',
    backToLogin: 'Back to login',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    submitting: 'Sending...',
    submit: 'Send reset link',
  },

  resetPassword: {
    linkExpired: 'The reset link has expired. Please request a password reset again.',
    linkInvalid: 'This link is invalid. Please request a password reset again.',
    passwordMismatch: 'The passwords do not match',
    passwordMin: 'Your password must be at least 8 characters',
    updateFailed: 'Failed to update the password. Please try again.',
    linkErrorTitle: 'The link is invalid',
    requestAgain: 'Request a reset again',
    verifying: 'Verifying your credentials...',
    heading: 'Set a New Password',
    subtitle: 'Enter a password of at least 8 characters',
    successTitle: 'Password updated!',
    successBody: 'Redirecting to the login screen...',
    newPasswordLabel: 'New password',
    newPasswordPlaceholder: 'At least 8 characters',
    confirmLabel: 'Password (confirm)',
    confirmPlaceholder: 'Enter again',
    submitting: 'Updating...',
    submit: 'Update password',
  },
};
